var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.284,50.055L54.45,34.924V25.05c0-1.727-0.67-3.347-1.886-4.564C51.341,19.263,49.721,18.59,48,18.59 c-3.557,0-6.45,2.898-6.45,6.46v9.875l-17.834,15.13c-0.448,0.38-0.706,0.938-0.706,1.525v7.22c0,0.688,0.354,1.327,0.936,1.693 c0.583,0.366,1.313,0.406,1.932,0.109l15.673-7.541v11.133l-6.322,5.28c-0.455,0.38-0.718,0.942-0.718,1.535v4.4 c0,0.686,0.351,1.323,0.93,1.689c0.58,0.367,1.305,0.411,1.926,0.118L48,72.183l10.635,5.035c0.271,0.129,0.563,0.192,0.855,0.192 c0.373,0,0.744-0.104,1.069-0.311c0.579-0.366,0.931-1.004,0.931-1.689v-4.4c0-0.593-0.263-1.155-0.718-1.535l-6.322-5.28V53.062 l15.673,7.541c0.62,0.298,1.35,0.256,1.932-0.109c0.582-0.366,0.936-1.006,0.936-1.693v-7.22 C72.99,50.993,72.732,50.435,72.284,50.055z M68.99,55.618l-15.673-7.541c-0.62-0.298-1.35-0.257-1.932,0.109 s-0.936,1.006-0.936,1.693v15.25c0,0.593,0.263,1.155,0.718,1.535l6.322,5.28v0.305l-8.634-4.088 C48.585,68.034,48.292,67.97,48,67.97s-0.585,0.064-0.856,0.192L38.51,72.25v-0.305l6.322-5.28c0.455-0.38,0.718-0.942,0.718-1.535 V49.88c0-0.688-0.354-1.327-0.936-1.693c-0.583-0.366-1.312-0.407-1.932-0.109L27.01,55.618v-3.112l17.834-15.131 c0.448-0.38,0.706-0.938,0.706-1.525v-10.8c0-1.356,1.099-2.46,2.45-2.46c0.652,0,1.269,0.257,1.735,0.724 c0.461,0.461,0.715,1.078,0.715,1.736v10.8c0,0.587,0.258,1.145,0.706,1.525L68.99,52.506V55.618z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.714a0cf7778d8ac718444fc70c582ae5.svg";
export { ForwardRef as ReactComponent };